import create from 'zustand';
import Cookies from 'js-cookie';

export type Project = {
  id: number;
  name: string;
  project_categories: ProjectCategory[] | undefined;
  admin_categories: AdminCategory[] | undefined;
};

export type ProjectCategory = {
  id: number;
  project_id: number;
  category_code: string;
  name: string;
};

export type AdminCategory = {
  id: number;
  project_id: number | undefined;
  category_code: string;
  name: string;
};

type ProjectStore = {
  project: Project | undefined;
  projectCategory: ProjectCategory | undefined;
  subProjectCategory: ProjectCategory | undefined;  // 要件等: ダウンロードボタンなど
  adminCategory: AdminCategory | undefined;
  setProject: ( project: Project | undefined ) => void;
  setProjectCategory: ( category: ProjectCategory | undefined ) => void;
  setSubProjectCategory: ( category: ProjectCategory | undefined ) => void;
  setAdminCategory: ( adminCategory: AdminCategory | undefined ) => void;
  isMenuOpen: boolean;
  setIsMenuOpen: ( isMenuOpen: boolean ) => void;
};

export const useProjectStore = create<ProjectStore>(( set ) => ({
  project: undefined,
  projectCategory: undefined,
  adminCategory: undefined,
  subProjectCategory: undefined,
  isMenuOpen: false, // Cookies.get('sideMenuOpen') === 'true',
  setProject: ( project ) =>
    set(( state ) => ({
      project: project,
    })),
  setProjectCategory: ( projectCategory ) =>
    set(( state ) => ({
      projectCategory: projectCategory,
    })),
  setSubProjectCategory: ( subProjectCategory ) =>
    set(( state ) => ({
      subProjectCategory: subProjectCategory,
    })),
  setAdminCategory: ( adminCategory ) =>
    set(( state ) => ({
      adminCategory: adminCategory,
    })),
  setIsMenuOpen: ( isMenuOpen ) =>
    set(( state ) => ({
      isMenuOpen: isMenuOpen,
    })),
}));
